import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { PredefinedStateMachines, ResourceType } from 'src/models';
import { getPredefinedStateMachine } from 'src/store/predefinedLists/predefinedLists.getters';
import { getAppParams } from 'src/store/app/app.getters';
import { requestPredefinedLists } from 'src/store/predefinedLists/predefinedLists.actions';
import { PROJECT_PREDEFINED_STATE_MACHINES, TRADE_PREDEFINED_STATE_MACHINES } from 'src/data/predefinedLists.data';
import { removePredefinedStateMachine } from 'src/store/predefinedLists/predefinedLists.reducer';

/**
 * hook for using some predefined state machine on the page that is not part of initial predefined lists
 * @param name - name of the predefined state machine
 */
export const usePredefinedStateMachine = (name?: PredefinedStateMachines) => {
  const dispatch = useDispatch();

  const { subId, tradeId } = useSelector(getAppParams);

  const data = useSelector(getPredefinedStateMachine)(name);

  useEffect(() => {
    if (data || !name) return;

    if (PROJECT_PREDEFINED_STATE_MACHINES.includes(name) && subId) {
      dispatch(
        requestPredefinedLists({
          lists: [name],
          resource_id: subId,
          resource_type: ResourceType.PROJECT,
        }),
      );
    } else if (TRADE_PREDEFINED_STATE_MACHINES.includes(name) && tradeId) {
      dispatch(
        requestPredefinedLists({
          lists: [name],
          resource_id: tradeId,
          resource_type: ResourceType.TRADE_CONTRACT,
        }),
      );
    }
  }, [dispatch, data, name, subId, tradeId]);

  useEffect(
    () => () => {
      if (name) dispatch(removePredefinedStateMachine(name));
    },
    [dispatch, name, subId, tradeId],
  );
};
